import React, { useEffect } from "react";
import "./News_detail.css";

import { useDispatch, useSelector } from "react-redux";
import { getNew } from "../../../actions/new.action";
import { getNews } from "../../../actions/news.action";
import { useNavigate, useParams } from "react-router";
import i18next from "i18next";
import { formatMonth } from "../../formatMonth";
import moment from "moment";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Preloader from "../../Preloader";
import { API_URI } from "../../../axios";
import { CiCalendar } from "react-icons/ci";
import plane_left from "../../../assets/images/Frame_238.png";
import PageHeader from "../../../Components/page-header/PageHeader";

/* "install": "npm i --save --force", */

const News_detail = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const language = i18next.language;

  useEffect(() => {
    dispatch(getNew(id, language));
    dispatch(getNews(language));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, language]);

  const new_ss = useSelector((state) => state.new);

  const newsss = new_ss.new;

  const data = newsss;

  const news_s = useSelector((state) => state?.news);

  const { news } = news_s;
  const { results } = news;

  const formatDate = (date) => {
    if (!date) return "";
    const month = moment(date).format("MM");
    return `${formatMonth(month, language)} ${moment(date).format(
      "DD, YYYY, HH:mm"
    )}`;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative bg-gray-100">
      <Helmet>
        <title>{`${t("news")} - ${t("Ashgabat_International_Airport")}`}</title>
      </Helmet>
      {!data ? (
        <Preloader />
      ) : (
        <div className="news-details flex flex-row">
          <PageHeader
            title={t("news")}
            breadCrumbItems={[
              { label: t("home"), path: "/" },
              { label: t("news"), path: "/news" },
              { label: data?.title, path: "#", active: true },
            ]}
          />
          <div className="container pt-12">
            <div className="row">
              <div className="col-xl-8 col-lg-7 gap-x-6">
                <div
                  className="news-details__left p-4 bg-white rounded-lg"
                  style={{ boxShadow: "0px 4px 10px 0px #0000000D" }}
                >
                  <div className="flex flex-col">
                    <div className="capitalize">
                      <p className="text-[16px] text-gray-400 flex flex-row gap-x-2 items-center">
                        <CiCalendar color="#000" />{" "}
                        {formatDate(data.created_at)}
                      </p>
                    </div>
                    <h3 className="mb-4">{data?.title}</h3>
                    <img
                      src={`${API_URI}${data?.image}`}
                      className="mobileS:w-full sm:w-[70%] mx-auto rounded-lg"
                      alt=""
                    />
                  </div>
                  <div className="news-details__content my-4">
                    <p
                      className="news-details__text-1 font-medium"
                      dangerouslySetInnerHTML={{ __html: data?.content }}
                    ></p>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-5 rounded-lg">
                <div className="sidebar rounded-lg">
                  <div className="sidebar__single sidebar__post">
                    <h3 className="sidebar__title flex items-center gap-2">
                      <div>{t("latest_news")}</div>
                      <img src={plane_left} />
                    </h3>
                    <ul className="sidebar__post-list list-unstyled  overflow-y-hidden">
                      {results
                        ? results.slice(0, 5).map((item, index) => {
                            return item.id === Number(id) ? (
                              ""
                            ) : (
                              <li
                                key={item.id}
                                className="flex flex-row gap-x-6"
                              >
                                <div className="w-full aspect-video min-w-[100px] max-w-[100px]">
                                  <img
                                    src={`${API_URI}${item.image}`}
                                    className="w-full rounded-md object-contain aspect-video"
                                    alt=""
                                  />
                                </div>
                                <div className="sidebar__post-content">
                                  <h3>
                                    <span className="sidebar__post-content-meta capitalize">
                                      <i className="fas fa-calendar"></i>
                                      {formatDate(item.created_at)}
                                      {/* ,{" "} */}
                                      {/* {moment(item.created_at).format("HH:mm")} */}
                                    </span>
                                    <Link to={`/news/${item.id}`}>
                                      {item.title}
                                    </Link>
                                  </h3>
                                </div>
                              </li>
                            );
                          })
                        : null}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default News_detail;
